import React from 'react';
import * as PropTypes from 'prop-types';

import { Upload as KendoUpload } from '@progress/kendo-react-upload';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error, Hint } from '@progress/kendo-react-labels';

export const Signature = (fieldRenderProps) => {
    const {valid, value, id, optional, label, hint, validationMessage, touched} = fieldRenderProps;
    const imgRef = React.useRef(null);
    const hasImage = value && value.length > 0;
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;

    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    const onChangeHandler = (event) => {
        fieldRenderProps.onChange({ value: event.newState });
    };
    const onRemoveHandler = (event) => {
        fieldRenderProps.onChange({ value: event.newState });
    };

    React.useEffect(() => {
        if (hasImage) {
            const reader = new FileReader();
    
            reader.onload = (e) => {
                if (imgRef.current) {
                    imgRef.current.setAttribute('src', e.target.result);
                }
            };
    
            reader.readAsDataURL(value[0].getRawFile());
        }
    }, [value, hasImage]);

    return (
        <FieldWrapper>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '123px' }}>
                <Label id={labelId} editorId={id} editorValid={valid} optional={optional} style={{ margin: 0 }}>
                    Signatur
                </Label>
                <div style={{ marginLeft: '-24px' }}className={'k-form-field-wrap'}>
                    <KendoUpload
                        id={id}
                        valid={valid}
                        autoUpload={false}
                        showActionButtons={false}
                        multiple={false}
                        files={value}
                        className="custom-upload-width"
                        onAdd={onChangeHandler}
                        onRemove={onRemoveHandler}
                        ariaDescribedBy={`${hintId} ${errorId}`}
                        ariaLabelledBy={labelId}

                    />
                    {
                        showHint &&
                        <Hint id={hintId}>{hint}</Hint>
                    }
                    {
                        showValidationMessage &&
                        <Error id={errorId}>{validationMessage}</Error>
                    }
                </div>
            </div>
        </FieldWrapper>
    );
};

Signature.displayName = 'Signature';
Signature.propTypes = {
    valid: PropTypes.bool,
    value: PropTypes.array,
    id: PropTypes.string,
    optional: PropTypes.bool,
    label: PropTypes.string,
    hint: PropTypes.string,
    validationMessage: PropTypes.string,
    visited: PropTypes.bool,
};

// CSS hinzufügen
const styles = document.createElement('style');
styles.innerHTML = `
.custom-upload-width .k-upload {
    width: 200px;
}
`;
document.head.appendChild(styles);